import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { isNonEmptyString, isDefinedNotNull, isDate, isNumber } from "../utils/validators.js";
import { InvalidParameterError } from "../utils/errors/index.js";
export function getLeaderboardInstances(_x) {
  return _getLeaderboardInstances.apply(this, arguments);
}

function _getLeaderboardInstances() {
  _getLeaderboardInstances = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var request, leaderboardSlug, instanceSlug, groupSlug, cycleId, date, userId, instances;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            request = _ref.request, leaderboardSlug = _ref.leaderboardSlug, instanceSlug = _ref.instanceSlug, groupSlug = _ref.groupSlug, cycleId = _ref.cycleId, date = _ref.date, userId = _ref.userId;

            if (isNonEmptyString(leaderboardSlug)) {
              _context.next = 3;
              break;
            }

            throw new InvalidParameterError(1622192256, 'Parameter "leaderboardSlug" must be a non-empty string.');

          case 3:
            if (!(isDefinedNotNull(instanceSlug) && !isNonEmptyString(instanceSlug))) {
              _context.next = 5;
              break;
            }

            throw new InvalidParameterError(1622192685, 'If provided parameter "instanceSlug" must be a non-empty string.');

          case 5:
            if (!(isDefinedNotNull(groupSlug) && !isNonEmptyString(groupSlug))) {
              _context.next = 7;
              break;
            }

            throw new InvalidParameterError(1622192713, 'If provided parameter "groupSlug" must be a non-empty string.');

          case 7:
            if (!(isDefinedNotNull(userId) && !isNonEmptyString(userId))) {
              _context.next = 9;
              break;
            }

            throw new InvalidParameterError(1622192915, 'If provided parameter "userId" must be a non-empty string.');

          case 9:
            if (!(isDefinedNotNull(date) && !isDate(date))) {
              _context.next = 11;
              break;
            }

            throw new InvalidParameterError(1622193008, 'If provided parameter "date" must be a Date object.');

          case 11:
            if (!(isDefinedNotNull(cycleId) && !isNumber(cycleId))) {
              _context.next = 13;
              break;
            }

            throw new InvalidParameterError(1622199610, 'If provided parameter "cycleId" must be a number');

          case 13:
            _context.next = 15;
            return request({
              method: 'GET',
              path: "/api/v1/leaderboards/".concat(leaderboardSlug, "/instances"),
              params: _objectSpread({
                instanceSlug: instanceSlug,
                groupSlug: groupSlug,
                cycleId: cycleId,
                userId: userId
              }, date ? {
                date: date.getTime()
              } : {})
            });

          case 15:
            instances = _context.sent;
            return _context.abrupt("return", instances.map(function (instance) {
              var startDate = instance.startDate,
                  endDate = instance.endDate;
              return _objectSpread(_objectSpread(_objectSpread({}, instance), startDate ? {
                startDate: new Date(startDate)
              } : {}), endDate ? {
                endDate: new Date(endDate)
              } : {});
            }));

          case 17:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getLeaderboardInstances.apply(this, arguments);
}